// @flow
import { ReducerRegistry } from "../../../base/redux";
import * as actionTypes from "../../actionTypes";

const STORE_NAME = "features/nxatel_call";

// PersistenceRegistry.register(STORE_NAME, {
//     // meetings_list:[]
// });

const DEFAULT_STATE = {
    recent_call_list:[],
    recent_call_count:0,
    all_recording_list:[],
    all_destination_list:[],
    all_recording_count:0,
    destination_number:'',
    call_details:[],
    assigned_number_list:[],
    scheduled_call_list:[],
    notes_list:[],
    force_call:'',
    tagged_number_listing:[],
    isTagged:'',
    newMessageCount:0,
    planner_details:{},
    individual_call_history:[],
    force_open_dialpad:{},
    voicemail_list:[],
    authorized_user:true,
    tag_listing:[],
    sms_chat_list:[],
    sms_chat_history:[],
    onboard_process_statics : {}
};

ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case actionTypes.FETCH_RECENT_CALL_LISTING:
            return {
                ...state,
                recent_call_list: action.payload,
            };
        case actionTypes.CALL_LISTING_COUNT:
            return {
                ...state,
                recent_call_count: action.payload,
            }
        case actionTypes.FETCH_ALL_RECORDING_LISTING:
            return {
                ...state,
                all_recording_list: action.payload,
            }
        case actionTypes.FETCH_VOICEMAIL_LISTING:
            return {
                ...state,
                voicemail_list: action.payload,
            }
        case actionTypes.FETCH_ALL_DESTINATION_LISTING:
            return {
                ...state,
                all_destination_list: action.payload,
            }
        case actionTypes.ALL_RECORDING_COUNT:
            return {
                ...state,
                all_recording_count: action.payload,
            };
        case actionTypes.DESTINATION_NUMBER:
            return {
                ...state,
                destination_number: action.payload,
            };
        case actionTypes.FETCH_CALL_DETAILS:
            return {
                ...state,
                call_details: action.payload,
            };
        case actionTypes.INDIVIDUAL_CONTACT_CALL_HISTORY:
            return {
                ...state,
                individual_call_history: action.payload,
            };
        case actionTypes.FETCH_ASSIGNED_NUMBER_LIST:
            return {
                ...state,
                assigned_number_list: action.payload,
            };
        case actionTypes.FETCH_ISTAGGED_NUMBER:
            return {
                ...state,
                isTagged: action.payload,
            };
        case actionTypes.FETCH_SCHEDULED_CALL_LISTING:
            return {
                ...state,
                scheduled_call_list: action.payload,
            };
        case actionTypes.FETCH_NOTES_LISTING:
            return {
                ...state,
                notes_list: action.payload,
            };
        case actionTypes.FETCH_TAGGED_NUMBER_LISTING:
            return {
                ...state,
                tagged_number_listing: action.payload,
            };
        case actionTypes.FORCE_OPEN_DIALPAD:
            return {
                ...state,
                force_open_dialpad: action.payload,
            };
        case actionTypes.FORCE_CALL:
            return {
                ...state,
                force_call: (action.payload).replace("+",''),
            };
        case actionTypes.NEW_MESSAGE_COUNT:
            return {
                ...state,
                newMessageCount: action.payload,
            };
        case actionTypes.FETCH_PLANNER_DETAILS:
            return {
                ...state,
                planner_details: action.payload,
            };
        case actionTypes.AUTHORIZED_USER:
            return {
                ...state,
                authorized_user: action.payload,
            };
        case actionTypes.GET_TAG_LISTING:
            return {
                ...state,
                tag_listing: action.payload,
            };
        case actionTypes.FETCH_SMS_CHAT_LISTING:
            return {
                ...state,
                sms_chat_list:action.payload,
            } 
        case actionTypes.FETCH_SMS_CHAT_HISTORY:
            return {
                ...state,
                sms_chat_history:action.payload,
            } 
        case actionTypes.FETCH_ONBOARD_PROCESS_STATICS:
            return {
                ...state,
                onboard_process_statics:action.payload,
            } 
        default:
            return state;
    }
});
